export const RECONNECT_BACKOFF_COUNT = 3;
export const RECONNECT_DELAY = 1000;
export const CHAT_STATE = 'chat_state';
export const WELCOME_QUERY_ID = 'welcome';
export const SUGGESTED_QUERIES_QUERY_ID = 'suggested_queries';
export const MAX_SESSION_AGE = 1000 * 60 * 60 * 24 * 1; // 1 day
